import { PlatformAdapter } from '@/platform/types';

export class CapacitorPlatformAdapter implements PlatformAdapter {
  label = 'capacitor';
  isNative = true;

  vibrate(_pattern: number | number[]) {
    // Placeholder adapter to keep the API stable for a future Capacitor migration.
  }

  openExternalUrl(url: string) {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
